import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { rem } from 'design-system/values';
import { AddToWatchListFlow } from 'utils/types/navigation';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { useWatchlistCache } from '../hooks/selectors';
import WatchListItemWithActions from './WatchListItemWithActions';
import CreateNewWatchListBtn from './CreateNewWatchListBtn';
const AddToWatchListModalContent = ({ closeModal, assetId }) => {
    const navigation = useMainStackNavigation();
    const watchlists = useWatchlistCache();
    const renderWatchLists = useMemo(() => {
        if (!watchlists?.length)
            return null;
        return (<>
        {watchlists.map((watchlist) => (<WatchListItemWithActions id={watchlist.id} key={watchlist.id} assetId={assetId} name={watchlist.name} emoji={watchlist.emoji}/>))}
      </>);
    }, [assetId, watchlists]);
    return (<View style={styles.modalContent}>
      {renderWatchLists}
      <CreateNewWatchListBtn onPress={() => {
            closeModal();
            navigation.navigateDeprecated('InvestCreateWatchList', {
                createParams: {
                    assetId,
                    flow: AddToWatchListFlow.AddToWatchListFromModal,
                },
            });
        }}/>
    </View>);
};
export default AddToWatchListModalContent;
const styles = StyleSheet.create({
    modalContent: {
        paddingBottom: rem(14),
    },
});
